import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SocialPostAgentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialPostAgent",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24 13.715H8c-.631 0-1.143.512-1.143 1.142V24c0 .63.512 1.143 1.143 1.143h16c.631 0 1.143-.512 1.143-1.143v-9.143c0-.63-.512-1.142-1.143-1.142m-1.143 9.142h-.923l-3.608-3.607a3.3 3.3 0 0 0-4.658 0l-3.607 3.607h-.918V16h13.714z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.286 2.286H5.714a3.43 3.43 0 0 0-3.428 3.428v20.572a3.43 3.43 0 0 0 3.428 3.428h20.572a3.43 3.43 0 0 0 3.428-3.428V5.714a3.43 3.43 0 0 0-3.428-3.428m1.142 24c0 .63-.512 1.143-1.142 1.143H5.714c-.63 0-1.142-.513-1.142-1.143V5.714c0-.63.512-1.143 1.142-1.143h20.572c.63 0 1.142.513 1.142 1.143z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 8h-9.143a1.143 1.143 0 1 0 0 2.285H24A1.143 1.143 0 1 0 24 8M9.143 11.429a2.29 2.29 0 0 0 2.286-2.286c0-1.26-1.026-2.286-2.286-2.286S6.857 7.883 6.857 9.143a2.29 2.29 0 0 0 2.286 2.286"
    })]
  }));
};
SocialPostAgentIcon.displayName = 'SocialPostAgentIcon';